import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DatiPignoramento } from 'src/app/common/models/dati-pignoramento/dati-pignoramento';

@Component({
    selector: '[add_doc_to_dati_pignoramento]',
  templateUrl: 'add-to-dati-pignoramento.component.html',
})

export class AddDocumentoToDatiPignoramentoComponent implements OnInit {
  @Input()
  datiPignoramento: DatiPignoramento;
  @Output()
  onClickAddToEntity = new EventEmitter();

  ngOnInit(): void {}
  
  emitEntity(elem: DatiPignoramento) {
    this.onClickAddToEntity.emit(elem);
  }
}
